export class PedagogicalModel {
    elaborate: number = 0
    engage: number = 0
    evaluate: number = 0
    explain: number = 7
    explore: number = 7
}
